import { Badge } from '@/components/ui/badge'
import { FLOW_LABEL, type FlowType } from '@/features/cases/types'

const FLOW_BADGE_CLASS: Record<FlowType, string> = {
  audit:
    'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-300',
  trades:
    'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-300',
  build:
    'border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-900 dark:bg-violet-950 dark:text-violet-300',
}

export function FlowBadge({ flow }: { flow: FlowType }) {
  return (
    <Badge variant="outline" className={FLOW_BADGE_CLASS[flow]}>
      {FLOW_LABEL[flow]}
    </Badge>
  )
}
